import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import state from './state'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'

import creator from './modules/creator'
import editor from './modules/editor'
import list from './modules/list'
import publicView from './modules/publicView'
import resource from './modules/resource'
import tomaner from './modules/tomaner'
import tree from './modules/tree'
import user from './modules/user'
import aboutme from './modules/aboutme'

export default new Vuex.Store({
  plugins: [createPersistedState({
    key: 'de.ul.fob',
    paths: [
      'confirmPrivacyPolicy',
      'lastVersion',
      'user.name',
      'user.roles',
      'user.orgas',
      'user.token',
      'user.savedViews',
      'user.selectedOrgaID',
      'user.fisPersid',
      'user.email',
      'user.forscher',
      'user.activeViewState',
      'tomaner.maco',
      'aboutme.name',
      'aboutme.fisPersid',
      'aboutme.leurisProfile',
      // disable the list attributes for debugging
      'list.resourceType',
      'list.listSchema',
      'list.filterSchema',
      'list.filter',
      'list.config',
      'creator.schema',
      'creator.data'
    ]
  })],
  state,
  getters,
  mutations,
  actions,
  modules: {
    creator,
    editor,
    list,
    publicView,
    resource,
    tomaner,
    tree,
    user,
    aboutme
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js